import styled from "styled-components"

export const Wrapper = styled.div`
  width:40px;
  height:40px;
  background:rgba(255,255,255,.5);
  border:1px solid rgba(255,255,255,.8);
  box-sizing:border-box;
  margin-left:5px;
  border-radius:3px;
`